<template>
  <div>
    <app-spinner v-if="page_loading" />
    <template v-else>
      <AppFlexGrid :rows="[['300px', '300px', '300px']]" margin-bottom="50px">
        <template #col-1-1><HMSearch @input.native="onItemSearch" v-model="filter_search" /></template>
        <template #col-1-2>
          <app-date-picker
            @input="onChangeFilter"
            v-model="filter_dates"
            class="family"
            placeholder="DD / MM / YY"
            range
          />
        </template>
        <template #col-1-3>
          <app-select
            @input="onChangeFilter"
            v-model="filter_source"
            :reduce="item => item.id"
            :options="source_options"
            placeholder="Source"
            class="family"
          />
        </template>
      </AppFlexGrid>
      <h2 class="hm-reslist__subtitle">Provisional</h2>
      <HMResListItem
        v-for="(res, index) in reservations_provisional"
        :key="res.id"
        :index-num="index"
        :res="res"
      />
      <app-cells position="between" style="max-width: 733px">
        <div>
          <paginate
            @input="onClickPaginationProvisional"
            v-if="pagination_provisional.pages > 1"
            v-model="pagination_provisional.page"
            :page-count="pagination_provisional.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_provisional.count" :count="reservations_provisional.length" :page="pagination_provisional.page" :limit="40" />
      </app-cells>
      <h2 class="hm-reslist__subtitle">Confirmed</h2>
      <HMResListItem
        v-for="(res, index) in reservations_confirmed"
        :key="res.id"
        :index-num="index"
        :res="res"
      />
      <app-cells position="between" style="max-width: 733px">
        <div>
          <paginate
            @input="onClickPaginationConfirmed"
            v-if="pagination_confirmed.pages > 1"
            v-model="pagination_confirmed.page"
            :page-count="pagination_confirmed.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_confirmed.count" :count="reservations_confirmed.length" :page="pagination_confirmed.page" :limit="40" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getHotelManagementReservationsV2, getHotelManagementSources } from '@/http'
import HMResListItem from '@/views/hotel-management/reservations/list/HMResListItem.vue'
import HMSearch from '@/views/hotel-management/reservations/components/HMSearch.vue'
import debounce from 'lodash/debounce'

export default {
  name: 'HotelManagementReservationsListUpcoming',
  components: {HMSearch, HMResListItem},
  data() {
    return {
      page_loading: true,
      filter_search: '',
      filter_source: null,
      filter_dates: [],
      source_options: [],
      reservations_provisional: [],
      reservations_confirmed: [],
      pagination_provisional: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_confirmed: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  created() {
    Promise.all([getHotelManagementSources(), this.fetchItemsProvisional(), this.fetchItemsConfirmed()])
      .then(response => {
        this.source_options = response[0].data
        this.page_loading = false
      })
  },
  methods: {
    async fetchItemsProvisional() {
      const res = await getHotelManagementReservationsV2({
        page: this.pagination_provisional.page,
        page_size: 40,
        category: 'upcoming',
        status: 'booked_provisionally',
        search: this.filter_search,
        source: this.filter_source,
        start_date__gte: this.filter_dates[0],
        end_date__lte: this.filter_dates[1],
      })
      this.reservations_provisional = res.data.results
      this.pagination_provisional.pages = res.data.pages
      this.pagination_provisional.count = res.data.count
    },
    async fetchItemsConfirmed() {
      const res = await getHotelManagementReservationsV2({
        page: this.pagination_confirmed.page,
        page_size: 40,
        category: 'upcoming',
        status: 'booked',
        search: this.filter_search,
        source: this.filter_source,
        start_date__gte: this.filter_dates[0],
        end_date__lte: this.filter_dates[1],
      })
      this.reservations_confirmed = res.data.results
      this.pagination_confirmed.pages = res.data.pages
      this.pagination_confirmed.count = res.data.count
    },
    onClickPaginationProvisional(page) {
      this.pagination_provisional.page = page
      this.fetchItemsProvisional()
    },
    onClickPaginationConfirmed(page) {
      this.pagination_confirmed.page = page
      this.fetchItemsConfirmed()
    },
    onChangeFilter() {
      this.filter_search = ''
      this.pagination_provisional.page = 1
      this.pagination_confirmed.page = 1
      this.fetchItemsProvisional()
      this.fetchItemsConfirmed()
    },
    onItemSearch() {
      this.searchItem(this)
    },
    searchItem: debounce(vm => {
      vm.pagination_provisional.page = 1
      vm.pagination_confirmed.page = 1
      vm.fetchItemsProvisional()
      vm.fetchItemsConfirmed()
    }, 350),
  }
}
</script>

<style>

</style>